import { render, staticRenderFns } from "./RecargosList.vue?vue&type=template&id=06b8bc79"
import script from "./RecargosList.vue?vue&type=script&lang=js"
export * from "./RecargosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports